import { render, staticRenderFns } from "./AddIndicador.vue?vue&type=template&id=074bd7ba"
import script from "./AddIndicador.vue?vue&type=script&lang=js"
export * from "./AddIndicador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports